import { handleAuthorization, handleOkResponseJson, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';
import { normalizeTextUppercase, normalizeItemsUppercase, normalizeItemsNullableIntegerFields } from '../utils'

export default {
	obterRequisicoesAsync,
	obterRequisicaoPorIdAsync,
	obterMetricasAsync,
	editarRequisicaoAsync,
	enviarRequisicaoAsync,
	inativarRequisicaoAsync,
	aprovarRequisicaoAsync,
	getPdf,
	downloadLista
}

const normalizeProdutosPayload = (produtos) => normalizeItemsNullableIntegerFields(
	normalizeItemsUppercase(produtos, ["observacao"]),
	["prazo"]
);

const normalizeRequisicaoServicoPayload = (payload) => {
	if (!payload) {
		return payload;
	}

	return {
		...payload,
		produtos: normalizeProdutosPayload(payload.produtos),
	};
};
export const obterRequisicoesAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/obterLista`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterRequisicaoPorIdAsync = async (id) => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/obterPorId/${id}`, requestOptions);
}

export const obterMetricasAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/metricas`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarRequisicaoAsync = async (prioridade, idUnidadeAdm, idLocal, observacao, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ prioridade, idUnidadeAdm, idLocal, observacao: normalizeTextUppercase(observacao), produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico`, requestOptions);
}

export const editarRequisicaoAsync = async (id,idUnidadeAdm, idLocal, observacao, prioridade, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, idUnidadeAdm, idLocal, observacao: normalizeTextUppercase(observacao), prioridade, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/atualizar`, requestOptions);
}

export const inativarRequisicaoAsync = async (id, justificativa) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, justificativa })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/inativar`, requestOptions);
}

export const aprovarRequisicaoAsync = async (id, observacaoAutorizador, produtos, idFornecedor) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeProdutosPayload(produtos), idFornecedor })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/aprovar`, requestOptions);
}

export const desautorizarRequisicaoAsync = async (id, observacaoAutorizador, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/desautorizar`, requestOptions);
}

export const declinarRequisicaoAsync = async (id, observacaoAutorizador) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/declinar`, requestOptions);
}

export const gerarPedidoRequisicaoAsync = async (payload) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify(normalizeRequisicaoServicoPayload(payload))
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/gerarPedido`, requestOptions);
}

export const aprovarPedidoRequisicaoAsync = async (id) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/aprovarPedido`, requestOptions);
}

export const declinarPedidoRequisicaoAsync = async (id, justificativa) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, justificativa: normalizeTextUppercase(justificativa) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/declinarPedido`, requestOptions);
}

export const salvarPedidoRequisicaoAsync = async (payload) => {
	const requestOptions = {
		method: 'PUT',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify(normalizeRequisicaoServicoPayload(payload))
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/RequisicaoServico/salvarPedido`, requestOptions);
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/RequisicaoServico/downloadRequisicoes`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'requisicoes_servico' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}


export function getPdf(id, janelaPdf = null) {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/RequisicaoServico/downloadPdf/` + id,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}
